module.exports = __webpack_public_path__ + "static/media/draxis-logo.7292e36c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners-list/images/draxis-logo.png
// module id = 776
// module chunks = 0